<template>
      <div class="wrapper">
       <!-- <article class="title">
        <h1 class="hi">‎SAMSUNG 隐私政策亮点 </h1>
        <p>Samsung Electronics 知晓隐私对我们的客户的重要性。我们确保您了解我们在所有 Samsung 设备和服务中，包括手机、平板电脑、电视、家用电器、在线服务等中，如何收集和使用您的个人信息。</p>
        <p>虽然本隐私政策适用于我们的所有服务，但如有必要，我们还将提供与特定服务相关的隐私的其他信息。</p>
        </article>

        <ol class ="info-list">
          <li class="info-item-0">
            <h2>个人信息概述</h2>
            <p>我们收集您直接提供的个人信息、有关您如何使用我们的服务的信息以及来自第三方的信息。我们使用这些信息为您提供服务和了解您使用我们服务的方式，以便我们能够改善和个性化您的体验，并为我们的客户开发最相关的应用、技术和内容。我们还使用个人信息提供根据个人兴趣量身定制的广告。</p>
            </li>
          <li class="info-item-1">
             <h2>分享您的个人信息</h2>
             <p>我们可能会与 Samsung Electronics 的关联公司以及代表 Samsung Electronics 提供服务的公司共享您的个人信息。我们还可能与值得信赖的合作伙伴公司(如移动服务提供商或保险公司)共享您的个人信息，这些公司为您提供您所请求的产品和服务以及您可能感兴趣的产品和服务信息。我们根据法律要求的目的而与执法机构共享个人信息。</p>     
          </li>
          <li class="info-item-2">
             <h2>本隐私政策将帮助您了解以下内容</h2>
               <ul class="two-depth">
                      <li>•	我们收集哪些信息</li>
                      <li>•	我们如何使用您的信息 </li>
                      <li>•	我们与谁共享您的信息</li>
                      <li>•	我们做些什么来保护您的信息安全</li>
                      <li>•	数据跨境传输</li>
                      <li>•	您的权利是什么</li>
                      <li>•	我们将您的信息保留多长时间</li>
                      <li>•	我们使用什么样的第三方服务</li>
                      <li>•	Cookie、信标和类似技术</li>
                      <li>•	我们如何保护儿童的信息</li>
                      <li>•	联系我们</li>
                    </ul>
          </li>
          <li class="info-item-3">
            <h1>SAMSUNG 隐私政策</h1>
            <p>生效日期: 2020 年 3 月 27 日</p>
            <br>
            <p>本隐私政策适用于我们所有的 Samsung 设备和服务，包括手机、平板电脑、电视、家用电器、在线服务等，它们统称为“服务”。</p>
            <p>经常查看隐私政策的更新非常重要。我们可能会定期更新本隐私政策，以反映与服务相关的个人信息实践的变更，或适用法律的变更。我们将在我们的网站或您的设备上发布通知，提前通知您我们的隐私政策的重大变化，并在隐私政策的顶端注明最近更新的时间。隐私政策的最新版本将始终在此处提供: <a class="link" href="https://account.samsung.com/membership/pp。">https://account.samsung.com/membership/pp。</a> </p>
          </li>
          <li class="info-item-4">
            <h2>我们收集哪些信息？</h2>
            <p>Samsung Electronics 将在征得您的同意后， 以多种方式收集您的个人信息。</p>
          </li>
          <li class="info-item-5">
            <h2>您直接提供的信息</h2>
            <p>某些服务要求您直接向我们提供信息。例如</p>
          
          </li>
          <li class="info-item-6">
            <h2>关于您使用服务的信息</h2>
            <p>除了您提供的信息，我们还将通过您设备上的软件和其他方式自动收集有关您使用我们服务的信息。我们将收集以下信息:</p>
              <ul class="two-depth">
                        <li> •	设备信息: 您的硬件型号、设备硬件信息、IMEI 号码和其他唯一设备标识符、电话号码、序列号、销售代码、访问记录、当前软件版本、MCC(移动国家/地区代码)、MCC(移动网络代码)、MAC 地址、IP 地址、Cookie、像素、订阅信息、操作系统版本以及用于访问服务的设备的设置。</li>
                        <li>•	日志信息: 诊断、技术、错误和使用信息，如您使用服务的时间和持续时间、在您的设备中输入与特定 Samsung 服务相关的搜索词条时的搜索查询词条，以及存储在我们在您的设备上设置的 Cookie 中的任何信息。</li>
                        <li>•	位置信息: 您的设备的 GPS 信号或附近 Wi-Fi 接入点和基站的信息，当您使用某些服务并启用位置功能时，这些信息可能会传输给我们。</li>
                        <li>•	语音信息: 当您启用此功能并使用语音命令控制服务或联系我们的客户服务团队时，我们生成并存储在我们的服务器上的语音记录。请注意，如果我们与代表我们提供语音到文本转换服务的受信任的第三方服务提供商合作，则该提供商可能会根据我们与之签订的合同接收和存储某些语音命令。</li>
                        <li>•	Samsung 键盘信息: 启用预测文本时键入的单词。此功能可能与您的 Samsung 帐户相关，用于同步数据，以便在您的其他 Samsung 移动设备上使用。您可以转到预测文本设置来清除该数据。</li>
                        <li>•	查看信息: 在您的设备上查看的网络、渠道、网站和程序以及查看它们所花费的时间。</li>
                        <li>•	有关您使用服务的其他信息，如使用的应用、访问的网站以及与通过服务提供的内容进行的交互等。</li>
                     </ul>
          </li>
         <li class="info-item-7">
            <h2>公开的、从市面上可获得的或共享信息</h2>
            <p>我们有时会收集公开的或从市面上可获得的信息，包括来自您使用的社交网络的信息，并将这些信息与您的其他信息结合起来，以便我们更好地了解您的需求、兴趣和偏好。当其他人使用我们的服务提供有关您的信息时，我们有时也会收集有关您的信息，例如其他人向您发送消息或与您共享文件时使用的您的姓名和联系信息。</p>     
          </li>
          <li class="info-item-8">
            <h2>我们收集的其他信息</h2>
            <p>我们还可能收集您同意发送给我们的有关您、您的设备或服务使用情况的其他信息。</p>
          </li>
         <li class="info-item-9">
            <h2>第三方分析</h2>
             <p>通过某些服务，我们可能会在一段时间内以及通过第三方网站、设备、应用和其他在线功能和服务收集有关您在网站和连接设备上的在线活动的个人信息。我们可能会在服务上使用第三方分析服务，例如 Google Analytics 的分析服务。管理这些分析服务的服务提供商可帮助我们分析您对服务的使用并改进服务。我们可能会向这些提供商以及其他需要使用此类信息来评估服务使用情况、帮助管理服务以及诊断技术问题的相关第三方披露我们获取的信息，他们也可能会直接收集此类信息。要了解有关 Google Analytics 的更多信息，请访问 <a class="link" href="http://www.google.com/analytics/learn/privacy.html">http://www.google.com/analytics/learn/privacy.html。</a>  和 <a class="link" href="https://www.google.com/policies/privacy/partners/">https://www.google.com/policies/privacy/partners/。</a> https://www.google.com/policies/privacy/partners/。</p>
          </li>
          <li class="info-item-10">
            <h2>您的选项</h2>
            <p>您可以选择不向我们提供某些类型的信息，例如在注册 Samsung 帐户时不填写某些信息。但在某些情况下，这可能会限制您使用某些服务的能力。当我们询问您的信息时，会尽量解释这些限制，以便您做出明智的决定。例如，三星云允许您备份信息并创建一个还原点；不过，设计三星云的意图不是为了存储或处理敏感信息。</p>
          </li>
          <li class="info-item-11">
            <h2>我们如何使用您的信息？</h2>
            <p>在征得您的同意后，我们将收集到的信息用于以下目的:</p>
              <ul class="two-depth">
                        <li>•	帮助您或您的设备注册我们的服务</li>
                        <li>•	提供您请求的服务或功能</li>
                        <li>•	根据您过去在我们的服务上的相关活动提供定制内容和个性化服务</li>
                        <li>•	在我们的网站、第三方网站和社交媒体网站等在线平台上提供您可能感兴趣的定制广告、促销和优惠</li>
                        <li>•	仅在您单独同意的情况下，以直接营销通信的方式提供促销和优惠</li>
                        <li>•	分析我们的产品和服务，帮助我们更好地了解我们的客户，以便为客户提供最相关的通信、服务和体验</li>
                        <li>•	根据需要，在您单独同意的情况下，征求您对我们的产品和服务的意见和进行客户调查</li>
                         <li>•	为您的设备提供软件更新、维护服务和支持</li>
                         <li>•	遵守法律和法律程序</li>
                         <li>•	保护 个人信息主体或其他个人的生命、财产或安全等重大合法权益。</li>
                     </ul>
              <br>
              <p>我们使用并整合从我们的服务、设备或其他来源收集的有关您的信息，为您提供更好的体验。例如，您不仅可以在注册的服务中使用您的 Samsung 帐户详细信息，还可以在使用 Samsung 帐户的其他服务中使用您的帐户详细信息。我们还使用您直接或通过上述其他来源提供的信息来提供您可能喜欢或个性化的内容。当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
              <p>您拥有选择如何处理您的信息的权利。请查看您的权利是什么？一节了解更多信息。</p>
          </li>
          <li class="info-item-11">
            <h2>[仅适用于欧洲经济区(EEA)居民]</h2>
            <p>Samsung 为实现上述目的处理个人信息。Samsung 处理个人信息的法律依据包括:</p>
              <ul class="two-depth">
                        <li>(i)	为兑现我们对您的承诺，比如为您提供服务</li>
                        <li>(ii)	为促进我们的商业利益(例如，管理我们与您的关系并改善您的客户服务体验)，包括在我们的网站、第三方网站和在线平台上的通信</li>
                        <li>(iii)	为遵守法律和法律程序</li>
                        <li>(iv)	已征得您的同意(例如，为了发送直接营销通信)。如果您想要撤销此同意，可随时通过本隐私政策的联系我们部分中指定的方式联系我们。</li>
              </ul>
              <p>Samsung Electronics 是您的个人信息的数据控制方，如上所述。对于欧洲的一些直接营销通信和一些定制广告，位于英国的 Samsung Electronics (UK) Limited 也是您个人信息的数据控制方。我们的一些欧洲 Samsung 子公司也在其所在国处理您的个人信息。在适用的情况下，欧洲 Samsung 子公司会在其网站上公布自己的本地隐私政策来解释这一点。</p>
           </li>
            <li class="info-item-11">
            <h2>我们与谁共享您的信息？</h2>
            <p>我们将在内部向需要信息以进一步提供服务或帮助您处理请求的人披露您的信息。</p>
            <p>我们还将向以下实体披露您的信息，但仅限于为提供我们的服务而需要的信息范围:</p>
              <ul class="two-depth">
                        <li>•	关联公司: 我们控制或拥有的其他 Samsung Electronics 集团公司。</li>
                        <li>•	业务合作伙伴: 与我们合作来为您提供您请求或购买的服务的合作伙伴。例如，我们可能会与银行合作，以便您可以使用我们的服务之一来更快、更高效地付款。这些业务合作伙伴控制和管理您的个人信息。</li>
                        <li>•	服务提供商: 精心挑选的为我们或代表我们提供服务的公司，例如帮助我们进行维修、客户联络中心、客户服务活动、广告(包括我们的网站、第三方网站或在线平台上的定制广告)服务、客户满意度调查、计费或代表我们发送电子邮件的公司。这些提供商也承诺保护您的信息。</li>
                        <li>•	法律要求或为保护我们的服务所需要的其他方: 例如，法律、法律程序或政府当局的法院命令可能要求披露您的信息。这些实体还可能出于执法、国家安全、反恐或其他与公共安全有关的问题的目的，向我们索取您的信息。</li>
                        <li>•	与公司交易有关的其他各方: 作为合并或转让、收购或出售的一部分，或在破产的情况下，我们可能会将您的信息披露给有关第三方。</li>
                        <li>•	获得您同意或按您的指示的其他各方: 除了本隐私政策中描述的披露外，当您单独同意或请求共享时，我们可能会与第三方共享有关您的信息。</li>
                     </ul>
              <br>
              <p>我们使用并整合从我们的服务、设备或其他来源收集的有关您的信息，为您提供更好的体验。例如，您不仅可以在注册的服务中使用您的 Samsung 帐户详细信息，还可以在使用 Samsung 帐户的其他服务中使用您的帐户详细信息。我们还使用您直接或通过上述其他来源提供的信息来提供您可能喜欢或个性化的内容。当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
              <p>您拥有选择如何处理您的信息的权利。请查看您的权利是什么？一节了解更多信息。</p>
          </li>
             <li class="info-item-12">
            <h2>我们做些什么来保护您的信息安全?</h2>
            <p>我们非常重视数据保护。我们落实了物理和技术方面的保障措施，以确保我们收集的信息的安全。但是请注意，尽管我们采取了合理的措施来保护您的信息，但网站、互联网传输、计算机系统或无线连接并不是绝对安全可靠的。</p>
            <p>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
          </li>
         <li class="info-item-13">
            <h2>数据跨境传输</h2>
             <p>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。请注意，您的信息可能传输到的国家/地区的数据保护措施和其他法律可能不像您所在国家/地区那样全面。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。</p>
            <br>
            <p>[仅适用于欧洲经济区(EEA)居民]</p>
            <br>
            <p>此外，您对服务的使用还可能涉及将您的个人信息传输、存储和处理到其他国家/地区；这些国家包括但不限于欧洲经济区国家、美国、中国、新加坡、越南、印度、加拿大、菲律宾和日本。我们将根据适用法律采取适当措施，以确保您的个人信息继续受到保护。这些措施包括使用标准合同条款来保障在欧洲经济区以外的数据传输。如需更多信息或想要获取现有合同协议的副本，请与我们联系。请参阅联系我们一节。</p>
          </li>
          <li class="info-item-14">
            <h2>您的权利是什么?</h2>
            <p>您的个人信息属于您。您可以要求我们提供我们收集的内容的详细信息，取得您的个人信息副本，也可以要求我们删除或纠正任何不准确之处。您还可以要求我们限制对您的个人信息的处理、共享或传输，以及获得我们收集的您的个人信息的内容，以便将其用于自己的目的。但是，要求删除您的个人信息也可能导致您无法访问我们提供的服务。我们不会删除法律要求我们保留的数据。</p>
            <p>每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时变更或撤回您的授权同意。当您变更或撤回同意后，我们将不再处理相应的个人信息。但您变更或撤回同意的决定，不会影响此前基于您的授权而处理的个人信息。您可注销此前注册的账户。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</p>
          <br>
          <p>如需就您的权利提出请求或进行查询，请与我们联系。请参阅联系我们一节。</p>
          </li>
          <li class="info-item-15">
            <h2>我们将您的信息保留多长时间？</h2>
            <p>我们保留您的个人信息的时间不会长于使用该信息所需的时间。这意味着，当不再需要该信息时，我们将从系统中销毁或删除它。</p>
            <br>
            <p>我们采取适当的措施来确保我们根据以下逻辑处理和保留有关您的信息:</p>
            <br>
           <ul class="two-depth">
                <li>1.	个人信息保存期限应为实现目的所必需的最短时间</li>
                <li>2.	根据法律、合同或我们的法定义务的要求</li>
                <li>3.	只保留实现收集、处理信息的目的所必需的时间，但可根据合同、适用法律的需要进行延长，并应采取适当的保障措施。</li>
              </ul>  
          </li>
          <li class="info-item-16">
            <h2>我们使用什么样的第三方服务?</h2>
            <p>我们服务中的某些内容、广告和功能由第三方提供。这些第三方可能会使用 Cookie、信标、跟踪像素和其他工具来收集有关您使用这些服务的信息。这些第三方不是由 Samsung 直接控制的，因此我们建议您检查他们的隐私政策，以了解他们如何使用您的数据。</p>
            <br>
            <p>对于某些应用和服务(包括社交网络)，我们会接收和存储登录信息以及您允许我们在您连接到这些应用和服务时接收的其他信息。</p>
          </li>
          <li class="info-item-17">
            <h2>Cookie、信标和类似技术</h2>
            <p>我们以及在我们的服务中提供内容、广告或其他功能的某些第三方，可能会在我们服务的某些领域使用 Cookie、像素、信标和其他技术。</p>
            <br>
            <p>Cookie</p>
            <p>Cookie 是在您的计算机、电视、手机或其他设备上存储信息的小文件。它们可让在您设备上放置 Cookie 的实体在不同的网站、服务、设备和浏览会话中识别您。Cookie 提供许多有用的用途。例如:</p>
            <ul class="two-depth">
                <li>•	Cookie 可以记住您的登录凭据，以便您不必每次登录服务时都要输入这些凭据。</li>
                <li>•	Cookie 帮助我们和第三方了解我们服务中的哪些部分是最受欢迎的，因为它们有助于我们了解访问者访问的页面和功能以及他们在页面上花费的时间。研究此类信息能够帮助我们更好地适应服务，从而为您提供更好的体验。</li>
                <li>•	Cookie 可帮助我们和第三方了解您看过哪些广告，这样您在每次访问服务时就不会收到相同的广告。</li>
                <li>•	Cookie 通过收集有关您使用我们的服务及其他网站和应用的信息，帮助我们和第三方为您提供相关内容和广告。</li>
              </ul>  
              <br>
              <p>当您使用 Web 浏览器访问服务时，可以将浏览器配置为接受所有 Cookie、拒绝所有 Cookie 或在发送 Cookie 时通知您。各个浏览器是不同的，所以，请检查浏览器的“帮助”菜单，了解如何更改您的 Cookie 偏好。您的设备的操作系统可能包含对 Cookie 的其他控制。请注意，某些服务可能被设计为使用 Cookie 工作，而禁用 Cookie 可能会影响您使用这些服务或其中某些功能的能力。</p>
              <br>
              <p>其他本地存储</p>
              <p>我们以及某些第三方可能会将我们的服务与其他类型的本地存储技术(例如本地共享对象(也称为“Flash Cookie”)和 HTML5 本地存储)结合使用。这些技术类似于上面讨论的 Cookie。它们存储在您的设备上，可用于存储有关您的活动和偏好的某些信息。但是，这些技术可能通过标准 Cookie 利用您的设备的不同部分，因此您可能无法使用标准浏览器工具和设置来控制它们。要了解如何禁用或删除本地共享对象中包含的信息，请访问 <a class="link" href="http://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html">http://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html。</a></p>
              <br>
              <p>信标</p>
              <p>我们和某些第三方也可能使用称为信标(或“像素”)的技术来将信息从您的设备传送到服务器上。信标可以嵌入到在线内容、视频和电子邮件中，并允许服务器从您的设备中读取某些类型的信息，了解您何时查看了特定内容或特定电子邮件，以及确定您查看设备的信标和 IP 地址的时间和日期。我们和某些第三方为了各种目的使用信标，包括分析我们的服务的使用情况，并会结合 Cookie 来提供与您更相关的内容和广告。</p>
          </li>
          <li class="info-item-18">
            <h2>我们如何保护儿童的信息</h2>
            <p>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>
          </li>
          <li class="info-item-19">
            <h2>联系我们</h2>
            <p>您可以联系我们以更新您的偏好、更正您的信息、提交请求或向我们提出问题。我们将在三十天内或者法律法规要求的期限内回复您的请求。</p>
            <br>
            <p>最简单的办法是通过 <a class="link" href="https://www.samsung.com/">https://www.samsung.com/</a>  的“联系我们”部分来联系。</p>
            <br>
            <p>您也可以通过以下地址联系我们:</p>
            <br>
            <p>数据控制方</p>
            <p>Samsung Electronics Co., Ltd.</p>
            <p>129, Samsung-ro, Yeongtong-gu,</p>
            <p>Suwon-si, Gyeonggi-do 16677, Republic of Korea</p>
            <br>
            <p>[仅适用于欧洲经济区(EEA)居民]</p>
            <br>
            <p>Samsung Electronics 在欧洲各地设有办事处，因此我们可以确保您的请求或查询将由您所在地区的数据保护团队处理。</p>
            <br>
            <p>联系我们的最简单办法是通过 <a class="link" href="https://www.samsung.com/request-desk">https://www.samsung.com/request-desk</a> https://www.samsung.com/request-desk 上的我们的“隐私支持页面”来联系。</p>
            <br>
            <p>您也可以通过以下地址联系我们:</p>
            <br>
            <p>European Data Protection Officer</p>
            <p>Samsung Electronics (UK) Limited</p>
            <p>Samsung House, 1000 Hillswood Drive, Chertsey, Surrey KT16 0PS</p>
            <br>
            <p>如果您认为我们对您的个人信息的处理违反了适用法律，可以向相关监管机构提出投诉。有关所有欧盟监管机构的联络资料，请访问 <a class="link" href="https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080">https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080。</a> </p>
          </li>
        </ol> -->
        </div>
</template>


<script>

export default {
  components: {
  },
  data() {
    return {
     };
  },
  created() {
   this.$router.push({ name: 'Home' });

  },
  methods: {

  }
};
</script>

<style scoped>
.wrapper {
  background-color: black;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;
    margin:auto;
}
.link{
  cursor: pointer;
}
/* .p{
  margin-block-start:1em;
  margin-block-end:1em;
} */
.hi{
  margin-top: 128px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
/* li{
  margin-top:4.453125vw;
} */
table{
  border-collapse:collapse;
  width:100%;
  text-align:center;
  margin-top:10px;
}
td,th{
  padding:0;
}
td,th{
  border: 1px solid #FFFFFF;
}
.info-item-0, .info-item-1,.info-item-2,.info-item-3,.info-item-4,.info-item-5,.info-item-6,.info-item-7,.info-item-8,.info-item-9,.info-item-10{
  margin-top:30px;
}
.info-item-2{
  margin-top:20px;
}
table.type-short{
  width:365px;
}
table.type-wide{
  width:920px;
}
ul,ol{
  list-style:none;
}
dl,ul,ol,dt,dd,blockquote,p,h1,h2,h3,h4,h5,h6{
  padding:0;
  margin:0;
  text-align:left;
}
tbody{
  display:table-row-group;
  vertical-align:middle;
}
@media (max-width: 1024px) {
  .wrapper{
    max-width: 83.33vw;
    margin:auto;
  }
 .hi{
  margin-top: 70px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
table.type-wide{
  max-width: 83.33vw;
}
table.type-short{
  max-width: 83.33vw;
}
table{
  margin-top:10px;
  margin-bottom:10px;
}
}
</style>


    
    
   
   
   
    
   